import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import DetailCard from '../../../shared/components/v3/Cards/DetailCard/DetailCard';
import { PLAN_ROUTE } from '../../../shared/constants/auth';
import { TRANSLATIONS_BENEFIT_CATEGORIES } from '../../../shared/constants/benefits';
import { CompanyContext } from '../../../shared/context/company/companyContext';
import { PlansContext } from '../../../shared/context/plans/plansContext';
import { useBenefitDetail } from '../../../shared/hooks/useBenefitDetail/useBenefitDetail';
import { categoryKeys } from '../../../shared/types/benefitTypes';
import DetailHeader from '../DetailHeader/DetailHeader';
import CoveragesCard from './sections/CoveragesCard/CoveragesCard';

import './InsuranceDetail.scss';

const InsuranceDetail = () => {
  const { company } = useContext(CompanyContext);
  const { selectedBenefit, selectedPlan } = useContext(PlansContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    benefit,
    loading: loadingDetail,
    error: errorDetail,
    refetch: refetchDetail
  } = useBenefitDetail(company.id, selectedBenefit?.benefitId ?? '');

  return (
    <div className="insurance-detail-container" data-experience="new">
      <DetailHeader
        title={selectedBenefit?.title ?? ''}
        tag={
          selectedBenefit?.category ? t(TRANSLATIONS_BENEFIT_CATEGORIES[selectedBenefit.category as categoryKeys]) : ''
        }
        tagVariant="fill"
        tagColor="fill-primary"
        backAction={() => navigate(PLAN_ROUTE)}
      />
      <div className="insurance-detail-content px-12 py-8">
        <div className="insurance-detail-description">
          <DetailCard
            title={benefit?.providerName ?? ''}
            icon={benefit?.icon}
            description={benefit?.description}
            type="detail"
            loading={loadingDetail}
            error={errorDetail}
            retry={refetchDetail}
          />
        </div>
        {/* <div className="insurance-detail-insight">
          <DetailCard
            title={t(TRANSLATION_MY_PLAN.cards.insuranceInsight.title, { percentage: `${insight}%` })}
            description={t(TRANSLATION_MY_PLAN.cards.insuranceInsight.description)}
            type="insight"
            loading={loadingInsight}
            error={errorInsight}
            retry={getInsight}
          />
        </div> */}
        <div className="insurance-detail-coverages">
          <CoveragesCard
            companyId={company.id}
            benefitId={selectedBenefit?.benefitId ?? ''}
            planId={selectedPlan?.id.toString() ?? ''}
          />
        </div>
      </div>
    </div>
  );
};

export default InsuranceDetail;
